<template>
  <a-modal
    width="1000px"
    :body-style="bodyStyle"
    :visible="modalVisible"
    @cancel="modalCancel"
    @ok="modalSubmit"
    cancelText="取消"
    okText="确认"
    :title="
      !modalType
        ? '创建活动规则'
        : modalType === 1
        ? '编辑活动规则'
        : '活动规则详情'
    "
  >
    <a-form
      ref="activityRef"
      :model="activityParams"
      :labelCol="{ span: 4 }"
      labelWrap
      :rules="activityRules"
    >
      <div style="font-size: 18px;margin-left: 8%;margin-bottom: 2%;">
        活动规则
      </div>
      <!-- <a-form-item label="品牌" name="brandId">
        <a-select
          v-model:value="activityParams.brandId"
          placeholder="请选择"
          style="width: 180px;margin-right: 20px;"
        >
        </a-select>
        <a-select-option
          :value="item.id"
          :key="key"
          v-for="(item, key) in brands"
          >{{ item.name }}</a-select-option
        >
      </a-form-item>
      <a-form-item label="渠道" name="channelId">
        <a-select
          v-model:value="activityParams.channelId"
          placeholder="请选择"
          style="width: 180px;margin-right: 20px;"
        >
        </a-select>
        <a-select-option
          :value="item.id"
          :key="key"
          v-for="(item, key) in channels"
          >{{ item.name }}</a-select-option
        >
      </a-form-item>
      <a-form-item label="站点" name="siteId">
        <a-select
          v-model:value="activityParams.siteId"
          placeholder="请选择"
          style="width: 180px;margin-right: 20px;"
        >
        </a-select>
        <a-select-option
          :value="item.id"
          :key="key"
          v-for="(item, key) in sites"
          >{{ item.name }}</a-select-option
        >
      </a-form-item>
      <a-form-item label="终端" name="terminalId">
        <a-select
          v-model:value="activityParams.terminalId"
          placeholder="请选择"
          style="width: 180px;margin-right: 20px;"
        >
        </a-select>
        <a-select-option
          :value="item.id"
          :key="key"
          v-for="(item, key) in terminals"
          >{{ item.name }}</a-select-option
        >
      </a-form-item> -->
      <a-form-item label="助力人数" name="helperNum">
        <p v-if="modalType === 2">
          <a-input
            v-model:value="activityParams.helperNum"
            :bordered="modalType !== 2"
          />
          <!-- {{ activityParams.helperNum }} -->
        </p>
        <div v-else>
          <a-button size="small" @click="delRow" style="padding: 0 17px;">
            -
          </a-button>
          <span
            style="
         display: inline-block;
         width: 8%;
         text-align: center;"
          >
            {{ activityParams.helperNum }}
          </span>
          <a-button size="small" @click="addRow" style="padding: 0 17px;">
            +
          </a-button>
          <span style="margin-left: 2%;">人</span>
        </div>
      </a-form-item>
      <a-form-item label="分享次数" name="shareNum">
        <p v-if="modalType === 2">
          <a-input
            v-model:value="activityParams.shareNum"
            :bordered="modalType !== 2"
          />
          <!-- {{ activityParams.shareNum }} -->
        </p>
        <div v-else>
          <a-button size="small" @click="delRowTwo" style="padding: 0 17px;">
            -
          </a-button>
          <span
            style="
          display: inline-block;
          width: 8%;
          text-align: center;"
          >
            {{ activityParams.shareNum }}
          </span>
          <a-button size="small" @click="addRowTwo" style="padding: 0 17px;">
            +
          </a-button>
          <span style="margin-left: 2%;">次</span>
          <span
            style="
            margin-left: 2%;
            color: rgb(170, 169, 169);
            font-size: 12px;"
          >
            配置"0"不做限制
          </span>
        </div>
      </a-form-item>
      <a-form-item label="助力次数" name="helpNum">
        <p v-if="modalType === 2">
          <a-input
            v-model:value="activityParams.helpNum"
            :bordered="modalType !== 2"
          />
          <!-- {{ activityParams.helpNum }} -->
        </p>
        <div v-else>
          <a-button size="small" @click="delRowThree" style="padding: 0 17px;">
            -
          </a-button>
          <span
            style="
          display: inline-block;
          width: 8%;
          text-align: center;"
          >
            {{ activityParams.helpNum }}
          </span>
          <a-button size="small" @click="addRowThree" style="padding: 0 17px;">
            +
          </a-button>
          <span style="margin-left: 2%;">次</span>
          <span
            style="
            margin-left: 2%;
            color: rgb(170, 169, 169);
            font-size: 12px;"
          >
            配置"0"不做限制
          </span>
        </div>
      </a-form-item>
      <a-form-item
        label="分享连接有效期"
        required
        name="shareLinkEffectTimeUnit"
      >
        <a-row>
          <a-col :span="6">
            <a-radio-group
              v-model:value="activityParams.shareLinkEffectTimeUnit"
              v-if="modalType !== 2"
              @change="selectType"
            >
              <a-radio :value="0">无限制</a-radio>
              <a-radio :value="1">自定义</a-radio>
            </a-radio-group>
            <p v-else>
              {{
                activityParams.shareLinkEffectTimeUnit === 0
                  ? '无限制'
                  : '自定义'
              }}
            </p>
          </a-col>
          <a-col :span="18">
            <div v-if="modalType === 2">
              <p v-if="activityParams.shareLinkEffectTimeUnit !== 0">
                <a-badge
                  :text="
                    activityParams.shareLinkEffectTime +
                      unitOps[activityParams.shareLinkEffectTimeUnitName]
                  "
                />
              </p>
            </div>
            <a-input-group compact v-else>
              <a-input-number
                v-model:value="activityParams.shareLinkEffectTime"
                placeholder="请输入"
                :min="1"
                :precision="0"
                :formatter="transformNum"
                :parser="transformNum"
                style="width: 30%"
                oninput="if (value < 0) value = 0"
                :disabled="activityParams.shareLinkEffectTimeUnit != 1"
              />
              <a-select
                v-model:value="activityParams.shareLinkEffectTimeUnitName"
                style="width: 16%"
                @change="changeDate"
                :disabled="activityParams.shareLinkEffectTimeUnit != 1"
              >
                <a-select-option :value="1" v-model="selected">
                  分钟
                </a-select-option>
                <a-select-option :value="2">小时</a-select-option>
                <a-select-option :value="3">天</a-select-option>
              </a-select>
            </a-input-group>
          </a-col>
        </a-row>
      </a-form-item>
      <a-form-item label="活动有效期" name="timeSet">
        <p v-if="modalType === 2">
          {{ activityParams.activityEffectStartTime }}
          ~
          {{ activityParams.activityEffectEndTime }}
        </p>
        <a-range-picker
          v-model:value="activityParams.timeSet"
          show-time
          :format="'YYYY-MM-DD HH:mm:ss'"
          :placeholder="['开始时间', '结束时间']"
          @change="timeChange"
          v-else
        />
      </a-form-item>
      <div style="font-size: 18px;margin-left: 6%;margin-bottom: 2%;">
        分享者奖励
      </div>
      <a-form-item
        label="规则ID"
        :key="
          +activityParams.sharerRewardType === 1
            ? 'sharerCouponRuleId'
            : 'sharerPointRuleId'
        "
        :name="
          +activityParams.sharerRewardType === 1
            ? 'sharerCouponRuleId'
            : 'sharerPointRuleId'
        "
      >
        <a-radio-group
          name="radioGroup"
          v-model:value="activityParams.sharerRewardType"
          class="mt10"
        >
          <a-radio :value="1">券规则</a-radio>
          <a-radio :value="2">积分</a-radio>
        </a-radio-group>
        <div class="mt10">
          <a-input
            v-model:value="activityParams.sharerCouponRuleId"
            v-if="+activityParams.sharerRewardType === 1"
            :disabled="modalType === 2"
            :bordered="modalType !== 2"
            style="width: 180px"
            placeholder="请输入券规则ID"
            :maxlength="50"
          />
          <a-input
            v-model:value="activityParams.sharerPointRuleId"
            v-else
            :disabled="modalType === 2"
            :bordered="modalType !== 2"
            style="width: 180px"
            placeholder="请输入积分ID"
            :maxlength="50"
          />
        </div>
      </a-form-item>
      <a-form-item
        label="券有效期"
        name="timeSetTwo"
        v-if="+activityParams.sharerRewardType === 1"
      >
        <p v-if="modalType === 2">
          {{ activityParams.sharerCouponStartTime }}
          ~
          {{ activityParams.sharerCouponEndTime }}
        </p>
        <a-range-picker
          v-model:value="activityParams.timeSetTwo"
          show-time
          :format="'YYYY-MM-DD'"
          :placeholder="['开始时间', '结束时间']"
          @change="timeChangeTwo"
          v-else
        />
      </a-form-item>
      <div style="font-size: 18px;margin-left: 6%;margin-bottom: 2%;">
        助力者奖励
      </div>
      <a-form-item
        label="规则ID"
        :key="
          activityParams.helperRewardType === 1
            ? 'helperCouponRuleId'
            : 'helperPointRuleId'
        "
        :name="
          activityParams.helperRewardType === 1
            ? 'helperCouponRuleId'
            : 'helperPointRuleId'
        "
      >
        <a-radio-group
          name="radioGroup"
          v-model:value="activityParams.helperRewardType"
        >
          <a-radio :value="1">券规则</a-radio>
          <a-radio :value="2">积分</a-radio>
        </a-radio-group>
        <div class="mt10">
          <a-input
            v-model:value="activityParams.helperCouponRuleId"
            v-if="+activityParams.helperRewardType === 1"
            :disabled="modalType === 2"
            :bordered="modalType !== 2"
            style="width: 180px"
            placeholder="请输入"
            :maxlength="50"
          />
          <a-input
            v-model:value="activityParams.helperPointRuleId"
            v-else
            :disabled="modalType === 2"
            :bordered="modalType !== 2"
            style="width: 180px"
            placeholder="请输入"
            :maxlength="50"
          />
        </div>
      </a-form-item>
      <a-form-item
        label="券有效期"
        name="timeSetThree"
        v-if="+activityParams.helperRewardType === 1"
      >
        <p v-if="modalType === 2">
          {{ activityParams.helperCouponStartTime }}
          ~
          {{ activityParams.helperCouponEndTime }}
        </p>
        <a-range-picker
          v-model:value="activityParams.timeSetThree"
          show-time
          :format="'YYYY-MM-DD'"
          :placeholder="['开始时间', '结束时间']"
          @change="timeChangeThree"
          v-else
        />
      </a-form-item>
      <div style="font-size: 18px;margin-left: 8%;margin-bottom: 2%;">
        链接配置
      </div>
      <a-form-item
        label="
          分享者领取成功弹窗shop now按钮
        "
        name="sharerSuccessUrl"
      >
        <a-textarea
          :rows="4"
          v-model:value="activityParams.sharerSuccessUrl"
          :disabled="modalType === 2"
          :bordered="modalType !== 2"
          style="width: 220px"
          placeholder="请输入"
        />
      </a-form-item>
      <a-form-item label="助力者落地页面" name="helperLandUrl">
        <a-textarea
          :rows="4"
          v-model:value="activityParams.helperLandUrl"
          :disabled="modalType === 2"
          :bordered="modalType !== 2"
          style="width: 220px"
          placeholder="请输入"
        />
      </a-form-item>
      <a-form-item
        label="
          助力者助力成功弹窗shop now按钮
          "
        name="helperSuccessUrl"
      >
        <a-textarea
          :rows="4"
          v-model:value="activityParams.helperSuccessUrl"
          :disabled="modalType === 2"
          :bordered="modalType !== 2"
          style="width: 220px"
          placeholder="请输入"
        />
      </a-form-item>
      <a-form-item
        label="
         活动结束弹窗shop now按钮
         "
        name="activityExpireUrl"
      >
        <a-textarea
          :rows="4"
          v-model:value="activityParams.activityExpireUrl"
          :disabled="modalType === 2"
          :bordered="modalType !== 2"
          style="width: 220px"
          placeholder="请输入"
        />
      </a-form-item>
      <a-form-item label="活动入口" required>
        <a-switch
          v-model:checked="activityParams.entranceStatus"
          :disabled="modalType === 2"
          :checkedValue="1"
          :unCheckedValue="0"
          checked-children="开"
          un-checked-children="关"
        >
        </a-switch>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { inject, toRefs } from 'vue'
export default {
  components: {},
  setup() {
    return {
      rule1: '1',
      rule2: '2',
      ...toRefs(inject('initState'))
    }
  }
}
</script>

<style lang="scss" scoped>
.ant-input[disabled] {
  color: #000;
}
.item {
  text-align: center;
  border: 1px solid #dedede;
  .label {
    padding: 10px 15px;
    white-space: nowrap;
  }
  .value {
    height: 100%;
    white-space: nowrap;
    padding: 10px 15px;
    border-top: 1px solid #dedede;
    .ant-form-item {
      margin: 0;
    }
  }
}
</style>
